<template>
    <div class="row">
        <div class="col-sm-2">
            <div class="row">
                <div class="col-auto col-sm-12">
                    <h4>學員姓名</h4>
                </div>
                <div class="col-auto col-sm-12">
                    <p>{{ student.Name }}</p>
                </div>
            </div>
        </div>
        <div class="col-sm-2">
            <div class="row">
                <div class="col-auto col-sm-12">
                    <h4>學員手機</h4>
                </div>
                <div class="col-auto col-sm-12">
                    <p>{{ student.CellPhone }}</p>
                </div>
            </div>
        </div>
        <div class="col-sm">
            <div class="row">
                <div class="col-auto col-sm-12">
                    <h4>電子信箱</h4>
                </div>
                <div class="col-auto col-sm-12">
                    <p>{{ student.Email }}</p>
                </div>
            </div>
        </div>
        <div class="col-sm">
            <div class="row">
                <div class="col-auto col-sm-12">
                    <h4>電子票卷</h4>
                </div>
                <div class="col-6 col-sm-12">
                    <a href="javascript:void(0);" class="qr_box" @click="showQrCode">展開票卷</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapMutations } from 'vuex'

    export default {
        props: {
            student: {
                type: Object,
                required: true
            }
        },
        methods: {
            ...mapMutations('student', [
                'setStudent',
                'setShowQrCodeModal',
            ]),
            showQrCode() {
                this.setStudent(this.student);
                this.setShowQrCodeModal(true);
            },
        },
    }
</script>